import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import FactorySettings from "./factory-settings.model";

export default class FactorySettingsFactory
  implements ObjectBuilderInterface<FactorySettings> {
  public buildFromJSON(data: { [key: string]: any }): FactorySettings {
    const value = new FactorySettings(
      data.factoryId,
      data.earlyArtworkAccessEnabled
    );

    value.isNew = false;

    return value;
  }
}
